import { connect } from "react-redux";
import { PageForgotMyPassword } from "senac-components";
import { PageForgotMyPasswordDispach, PageForgotMyPasswordStateProps } from "senac-components/dist/pages/Mobile/PageForgotMyPassword";
import { PageForgotMyPasswordWeb } from "senac-components/dist/pages/Web/PageForgotMyPassword";
import { AppDispatch, RootState } from "../store";
import { commonSlice, userSlice } from "../store/reducers";

const mapState = (state: RootState) => 
{
  let result: PageForgotMyPasswordStateProps = {
    loading : false,
    successMessage : false
  };

  return result;
};

const mapDispatch = (dispatch: AppDispatch) => 
{
  const result: PageForgotMyPasswordDispach = 
  {
    onSelectedHeaderMenuOption: ()=> {},
    onSelectedHeaderBack: () => dispatch(commonSlice.actions.backPage()),
    onClickBack: () => dispatch(commonSlice.actions.backPage()),
    onClickHelp: () => dispatch(commonSlice.actions.helpPage()),
    onClickRecover: (login:string) => dispatch(userSlice.actions.recoverPassword(login))
  };

  return result;
};

const WPageForgotMyPassword = () => {
  const Mobile = connect(mapState, mapDispatch)(PageForgotMyPassword);
  const Web = connect(mapState, mapDispatch)(PageForgotMyPasswordWeb);
  if(window.innerWidth < 1024) return <Mobile />
  return <Web />
}

export { WPageForgotMyPassword };

